module.exports = __webpack_public_path__ + "src/img/banana/4.png?d574dddd78e9a0a61cde24b06717f8a2";


//////////////////
// WEBPACK FOOTER
// ./src/img/banana/4.png
// module id = 170
// module chunks = 0